import React from 'react';

const MsgNetLoading = () => {
  return (
    <div className="flex justify-center items-center w-full min-h-screen">
      <div className="w-16 h-16 border border-ccnorte border-t-transparent rounded-full animate-spin"></div>
    </div>
  );
};

export default MsgNetLoading;
